import { createORPCReactQueryUtils } from "@orpc/react-query";
import { orpcClient } from "./client";

export const orpc = createORPCReactQueryUtils(orpcClient);
